import { Injectable, inject } from '@angular/core';

import { pluck } from 'rxjs/operators';

import type { GdprSaveBody } from '@core/gdpr-types';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class GdprConfigurationHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetch() {
    return this.httpApi.get('gdpr/configuration').pipe(pluck('configuration'));
  }

  public save(body: GdprSaveBody) {
    return this.httpApi.patch('gdpr/configuration', null, body).pipe(pluck('configuration'));
  }
}
